<template>
  <booking-block
    v-if="tourOperatorInfo"
    class="booking-block--payment-details"
    :valid="true"
    :editMode="false"
    :title="translations.header"
    :subTitle="tourOperatorInfo.name ? tourOperatorInfo.name : ''"
    :showEditBtn="false"
    :showSaveBtn="false"
    :isCollapsed="isCollapsed"
  >
    <template slot="view">
      <div class="booking-travel-agency-grid">
        <div class="to-block">
          <div class="to-block__header">
            <h3 v-if="tourOperatorInfo.name" v-text="tourOperatorInfo.name"></h3>
          </div>
          <div class="to-block__content">
            <p
              v-if="tourOperatorInfo.street"
              v-text="tourOperatorInfo.street"
            ></p>
            <p v-if="tourOperatorInfo.zipCode">
              {{ tourOperatorInfo.zipCode }}, {{ tourOperatorInfo.city }}
            </p>
            <p
              v-if="tourOperatorInfo.country"
              v-text="tourOperatorInfo.country.name"
            ></p>
          </div>
        </div>
        <img v-if="tourOperator && tourOperator.logo" :src="tourOperator.logo" :alt="tourOperator.name">
      </div>
    </template>
    <template slot="footer">
      <p v-text="noticeTxt" class="booking-travel-agency-notice"></p>
      <ul class="booking-travel-agency-list">
        <li>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 262.39 260.6" class="booking-icon booking-icon--check">
            <path d="M248.88,3.42c-13-7-29.61-2.92-37.16,9.08v0L105.62,181.3,49.94,108.64C41.73,97,24.88,93.75,12.31,101.35s-16.09,23.2-7.87,34.83c.38.54.78,1.06,1.2,1.57L91.87,250.39a27.19,27.19,0,0,0,17.47,10.21h.15A26.82,26.82,0,0,0,126,248.92L258.71,37.83C266.24,25.81,261.84,10.42,248.88,3.42Z" />
          </svg>
          <span v-text="translations.BookingCheckListPrice"></span>
        </li>
        <li>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 262.39 260.6" class="booking-icon booking-icon--check">
            <path d="M248.88,3.42c-13-7-29.61-2.92-37.16,9.08v0L105.62,181.3,49.94,108.64C41.73,97,24.88,93.75,12.31,101.35s-16.09,23.2-7.87,34.83c.38.54.78,1.06,1.2,1.57L91.87,250.39a27.19,27.19,0,0,0,17.47,10.21h.15A26.82,26.82,0,0,0,126,248.92L258.71,37.83C266.24,25.81,261.84,10.42,248.88,3.42Z" />
          </svg>
          <span v-text="translations.BookingCheckListFees"></span>
        </li>
      </ul>
    </template>
  </booking-block>
</template>

<script>
import _ from "underscore";
import BookingBlock from "./booking-block.vue";

export default {
  props: {
    isCollapsed: {type: Boolean, default: false}
  },
  data() {
    return {
      translations: APP_CONFIG.TRANSLATION.BOOKING_TOUROPERATOR,
    };
  },
  computed: {
    tourOperatorInfo() {
      return _.propertyOf(this.$store.state.selectedBookingOffer)([
        "verifiedOffer",
        "tourOperatorInformation",
        "tourOperator",
      ]);
    },
    tourOperator() {
      return _.propertyOf(this.$store.state.selectedBookingOffer)([
        "verifiedOffer",
        "packageOffer",
        "tourOperator",
      ]);
    },
    noticeTxt() {
      let TOName = this.tourOperatorInfo.name ? this.tourOperatorInfo.name : this.translations.agency;
      return this.translations.notice.replace(/{travel_agency}/, TOName);
    }
  },
  components: {
    BookingBlock,
  },
};
</script>
